import { Stack } from '@chakra-ui/react';
import HeaderSectionMobilePage from '../../../../components/Mobile/headerSection';
import { IRegistration } from '../../../../services/hooks/CandidateArea/useRequestMyRegistration';
import CardRegistrationMobilePage from './CardRegistration';

interface IOwnProps {
  selectiveProcess: IRegistration;
}

const ListRegistrationMobilePage: React.FC<IOwnProps> = ({ selectiveProcess }) => {
  const reg = selectiveProcess.registration;
  return (
    <Stack gap={0}>
      <HeaderSectionMobilePage>{selectiveProcess.selective_process_name}</HeaderSectionMobilePage>
      <CardRegistrationMobilePage
        registration={reg}
        isCultureHouse={selectiveProcess.is_cultural_house}
        selectiveProcessId={selectiveProcess.selective_process_id}
        isLegacy={selectiveProcess.is_legacy}
        allowFilterVacancyTree={selectiveProcess.allow_filter_vacancy_tree}
      />
    </Stack>
  );
};

export default ListRegistrationMobilePage;
